import BookListHeader from "../../components/BookListHeader";
import BookCards from "../../components/BookCards";
import { useState } from "react";

export default function Home() {
  const [filterby, setFilterby] = useState("all");

  return (
    <>
      <main class="py-12 px-6 2xl:px-6 container">
        <div class="order-2 xl:-order-1">
          <BookListHeader filterby={filterby} setFilterBy={setFilterby} />
          <BookCards filterby={filterby} />
        </div>
      </main>
    </>
  );
}
